import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { Headings, Margin } from '../../../..'

function SingleMessage({ index, message, t }) {
    return (
        <div title={message}>
            <Margin bottom size="xs">
                <Headings.H5 bold>{t('custom-message-title', { index })}</Headings.H5>
            </Margin>
            {message}
        </div>
    )
}

SingleMessage.propTypes = {
    index: PropTypes.number,
    message: PropTypes.number,
    t: PropTypes.func.isRequired,
}

SingleMessage.defaultProps = {
    index: null,
    message: '',
}

export default withTranslation()(SingleMessage)
